const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const AuditLogsQuery: any = {
    GetAuditLogs: Backofficebff + '/v1/auditlog/get-auditlogs',
};
